import Avatar, { Props as AvatarProps } from './Avatar';

export type { AvatarProps };
export default Avatar;
